import { render, staticRenderFns } from "./classPriceManagement.vue?vue&type=template&id=ea3fa5e8&scoped=true"
import script from "./classPriceManagement.vue?vue&type=script&lang=js"
export * from "./classPriceManagement.vue?vue&type=script&lang=js"
import style0 from "./classPriceManagement.vue?vue&type=style&index=0&id=ea3fa5e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3fa5e8",
  null
  
)

export default component.exports